import { RIMS_SESSION_STG_CONSTANTS } from "../constants";

/**
 * Builds absolute URL for Form Field List (same path as React Router).
 * Uses PUBLIC_URL when the app is deployed under a subpath.
 */
const FIELD_LIST_BASE = "/configuration/form-manager/fields";

/**
 * Query parameter carrying {@link RIMS_SESSION_STG_CONSTANTS.CURRENT_TENANT_ID} when opening
 * Field List in a new tab (new tabs do not inherit sessionStorage).
 */
export const FIELD_LIST_TENANT_QUERY_PARAM = "currentTenantId";

/**
 * Reads {@link FIELD_LIST_TENANT_QUERY_PARAM} from the current window URL, writes it to
 * sessionStorage under {@link RIMS_SESSION_STG_CONSTANTS.CURRENT_TENANT_ID}, and strips the
 * query param via replaceState. Call at module load (e.g. Field List page entry).
 */
export function syncFieldListTenantFromWindowToSession(): void {
  if (typeof window === "undefined") {
    return;
  }
  const params = new URLSearchParams(window.location.search);
  const tenantFromUrl = params.get(FIELD_LIST_TENANT_QUERY_PARAM);
  if (!tenantFromUrl) {
    return;
  }
  sessionStorage.setItem(
    RIMS_SESSION_STG_CONSTANTS.CURRENT_TENANT_ID,
    tenantFromUrl
  );
  params.delete(FIELD_LIST_TENANT_QUERY_PARAM);
  const search = params.toString();
  const url = `${window.location.pathname}${search ? `?${search}` : ""}${window.location.hash}`;
  window.history.replaceState(null, "", url);
}

export function getPublicUrlBase(): string {
  return (process.env.PUBLIC_URL || "").replace(/\/$/, "");
}

export function getFieldListPath(formId: string): string {
  const publicBase = getPublicUrlBase();
  const relative = `${FIELD_LIST_BASE}/${encodeURIComponent(formId)}`;
  return publicBase ? `${publicBase}${relative}` : relative;
}

export function getFieldListAbsoluteUrl(formId: string): string {
  return `${window.location.origin}${getFieldListPath(formId)}`;
}

export function openFieldListInNewTab(formId: string): void {
  if (!formId) {
    return;
  }
  let url = getFieldListAbsoluteUrl(formId);
  const tenantId = sessionStorage.getItem(
    RIMS_SESSION_STG_CONSTANTS.CURRENT_TENANT_ID
  );
  if (tenantId) {
    const sep = url.includes("?") ? "&" : "?";
    url = `${url}${sep}${encodeURIComponent(FIELD_LIST_TENANT_QUERY_PARAM)}=${encodeURIComponent(tenantId)}`;
  }
  window.open(url, "_blank", "noopener,noreferrer");
}

/** Disable "Go to Field List" when menu/step status is not Enable. */
export function isFieldListActionDisabled(status: string | undefined): boolean {
  return status !== "Enable";
}
